// src/api/form.js
import { BASE_URL, DEFAULT_HEADERS } from "../apiConfig";

export async function sendCallbackRequest(data) {
  const response = await fetch(
    `${BASE_URL}/callback-requests`,
    {
      method: "POST",
      headers: DEFAULT_HEADERS,
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    const error = await response.json();
    throw error;
  }

  return response.json();
}
